<template>
  <div :class="['sm:tw-mx-0 tw-bg-white sm:tw-rounded-lg', shadowClass, { 'tw--mx-4 tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6': !noPadding }]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    shadow: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shadowClass() {
      return this.shadow ? "tw-shadow" : "tw-border";
    },
  },
};
</script>
